// extracted by mini-css-extract-plugin
module.exports = {"container":"MinimalCard_container__1QcZa"};